import PropTypes from 'prop-types';

const StatusBadge = ({ variant, label, className }) => (
  <span className={`app-status-badge app-status-badge-${variant} ${className}`}>{label}</span>
);

StatusBadge.propTypes = {
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info', 'primary', 'secondary', 'dark', 'light']),
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
};

StatusBadge.defaultProps = {
  variant: 'secondary',
  className: '',
};

export default StatusBadge;
